import { useEffect, useRef, useState } from 'react';

const useOfferTimer = (priceEffectiveTill) => {
  const [time, setTime] = useState();
  const timerId = useRef();

  const getLiveTimeDifference = (endTime) => {
    const todayInMs = new Date().getTime();
    const targetDateInMs = new Date(endTime).getTime();

    const diffInMs = targetDateInMs - todayInMs;

    if (diffInMs > 0) {
      const diffInSec = Math.floor(diffInMs / 1000);
      const diffInHourMinSec = new Date(diffInSec * 1000)
        .toISOString()
        .substring(11, 19);
      setTime(`${diffInHourMinSec}`);
    } else {
      setTime();
    }
  };

  useEffect(() => {
    timerId.current = setInterval(
      () => getLiveTimeDifference(priceEffectiveTill),
      1000
    );
    return () => clearInterval(timerId.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [time, priceEffectiveTill]);

  const stopTimer = () => {
    clearInterval(timerId.current);
  };

  return { time, stopTimer };
};

export default useOfferTimer;
